import { useState, useEffect, useCallback } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import publicAPI from '../../publicApi';
import AppPrompt from '../../components/AppPrompt';
import './PublicPage.css';

/**
 * 공개 월간 리포트 페이지
 * URL: /:tenantId/reports/monthly/:id?token=xxx
 */
export default function PublicMonthlyReport() {
  const { tenantId, id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadReport = useCallback(async () => {
    if (!token) {
      setError('유효하지 않은 링크입니다');
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const { data } = await publicAPI.getMonthlyReport(tenantId, id, token);
      setReport(data);
      setError(null);
    } catch (err) {
      console.error('Failed to load monthly report:', err);
      setError(err.response?.data?.error || '월간 리포트를 불러오는데 실패했습니다');
    } finally {
      setLoading(false);
    }
  }, [tenantId, id, token]);

  useEffect(() => {
    loadReport();
  }, [loadReport]);

  if (loading) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="loading-spinner">로딩 중...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>⚠️ 오류</h3>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!report) {
    return (
      <div className="public-page">
        <div className="public-container">
          <div className="error-message">
            <h3>📊 월간 리포트를 찾을 수 없습니다</h3>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="public-page">
      <AppPrompt />
      <div className="public-container">
        <div className="public-header">
          <div className="header-badge">월간 리포트</div>
          <h1 className="public-title">{report.title || '월간 학습 리포트'}</h1>
          <div className="public-meta">
            <span className="meta-item">📅 {report.period || report.month}</span>
          </div>
        </div>

        <div className="public-section">
          <h2 className="section-title">📋 리포트 내용</h2>
          <div className="section-content">
            {report.content || '월간 리포트 데이터가 준비 중입니다.'}
          </div>
        </div>

        <div className="public-footer">
          <p className="footer-text">EduStaff 학원관리 시스템</p>
        </div>
      </div>
    </div>
  );
}
